import { render, staticRenderFns } from "./CouponSnapshot.vue?vue&type=template&id=5d9a5094&scoped=true&"
import script from "./CouponSnapshot.vue?vue&type=script&lang=js&"
export * from "./CouponSnapshot.vue?vue&type=script&lang=js&"
import style0 from "./CouponSnapshot.vue?vue&type=style&index=0&id=5d9a5094&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d9a5094",
  null
  
)

export default component.exports